import {Injectable, NgModule} from '@angular/core';
import {CanActivate, Router, RouterModule, Routes} from '@angular/router';
import {map, tap} from "rxjs/operators";
import {AdminPanelComponent} from './admin/admin-panel/admin-panel.component';
import {AdminSettingsComponent} from './admin/admin-settings/admin-settings.component';
import {AdminComponent} from './admin/admin/admin.component';
import {UserAdminComponent} from './admin/user-admin/user-admin.component';
import {HomeComponent} from './home/home/home.component';
import {NewOrderComponent} from './new-order/new-order/new-order.component';
import {AccountSuperAdminComponent} from './super-admin/account-super-admin/account-super-admin.component';
import {SuperAdminChannelComponent} from './super-admin/super-admin-channel/super-admin-channel.component';
import {SuperAdminPanelComponent} from './super-admin/super-admin-panel/super-admin-panel.component';
import {SuperAdminComponent} from './super-admin/super-admin/super-admin.component';
import {UserSuperAdminComponent} from './super-admin/user-super-admin/user-super-admin.component';
import {SuperAdminLoginComponent} from "./super-admin/super-admin-login/super-admin-login.component";
import {UserRole} from "src/app/auth/auth.model";
import {AuthManagerService} from "./auth/auth-manager.service";
import {PasswordResetComponent} from "./auth/password-reset/password-reset.component";
import {ReturnComponent} from './return/return/return.component';
import {SuperAdminCatalogsComponent} from "./super-admin/super-admin-catalogs/super-admin-catalogs.component";
import {SuperAdminOrderingComponent} from "./super-admin/super-admin-ordering/super-admin-ordering.component";
import {SuperAdminBannerComponent} from "./super-admin/super-admin-banner/super-admin-banner.component";
import {ManufacturingPageComponent} from "./super-admin/manufacturing-page/manufacturing-page.component";
import {
  ApexAccountSuperAdminComponent
} from "./super-admin/apex-account-super-admin/apex-account-super-admin.component";

@Injectable({
  providedIn: 'root'
})
export class NewOrderGuard implements CanActivate {
  constructor(
    private router: Router,
    private auth: AuthManagerService
  ) {
  }

  canActivate() {
    return this.auth.currentUser$.pipe(
      map(user => !!user),
      tap(success => {
        if (!success) {
          this.router.navigate(['/home']);
        }
      })
    );
  }
}

@Injectable({
  providedIn: 'root'
})
export class SaGuard implements CanActivate {
  constructor(
    private router: Router,
    private auth: AuthManagerService
  ) {
  }

  canActivate() {
    return this.auth.currentUser$.pipe(
      map(user => !!user && user.role === UserRole.SUPERADMIN),
      tap(success => {
        if (!success) {
          this.router.navigate(['/sa/login']);
        }
      })
    );
  }
}

@Injectable({
  providedIn: 'root'
})
export class AdminGuard implements CanActivate {
  constructor(
    private router: Router,
    private auth: AuthManagerService
  ) {
  }

  canActivate() {
    return this.auth.isAdmin$.pipe(
      tap(success => {
        if (!success) {
          this.router.navigate(['/home']);
        }
      })
    );
  }
}

const routes: Routes = [
  {path: '', redirectTo: '/home', pathMatch: 'full'},
  {path: 'home', component: HomeComponent},
  {path: 'password-reset', component: PasswordResetComponent},
  {
    path: 'admin',
    component: AdminComponent,
    canActivate: [AdminGuard],
    children: [
      {path: '', redirectTo: 'home', pathMatch: 'full'},
      {path: 'home', component: AdminPanelComponent},
      {path: 'users', component: UserAdminComponent},
      {path: 'settings', component: AdminSettingsComponent},
    ]
  },
  {
    path: 'sa',
    component: SuperAdminComponent,
    children: [
      {path: '', redirectTo: 'home', pathMatch: 'full'},
      {path: 'home', component: SuperAdminPanelComponent, canActivate: [SaGuard]},
      {path: 'accounts', component: AccountSuperAdminComponent, canActivate: [SaGuard]},
      {path: 'users', component: UserSuperAdminComponent, canActivate: [SaGuard]},
      {path: 'channel', component: SuperAdminChannelComponent, canActivate: [SaGuard]},
      {path: 'catalogs', component: SuperAdminCatalogsComponent, canActivate: [SaGuard]},
      {path: 'ordering', component: SuperAdminOrderingComponent, canActivate: [SaGuard]},
      {path: 'banner', component: SuperAdminBannerComponent, canActivate: [SaGuard]},
      {path: 'manufacture', component: ManufacturingPageComponent, canActivate: [SaGuard]},
      {path: 'manufacture', component: ManufacturingPageComponent},
      {path: 'login', component: SuperAdminLoginComponent},
      {path: 'apex',  component: ApexAccountSuperAdminComponent, canActivate: [SaGuard]}
    ]
  },
  {path: 'new-order', component: NewOrderComponent, canActivate: [NewOrderGuard], pathMatch: 'full'},
  {path: 'return', component: ReturnComponent, canActivate: [NewOrderGuard], pathMatch: 'full'}
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'enabled',
    anchorScrolling: 'enabled',
    scrollOffset: [0, 64]
  })],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
